<template functional>
  <label class="paa-fld">
    <span>{{ props.label }}</span>
    <select :value="props.value" @change="listeners.input && listeners.input($event.target.value)">
      <option v-for="option in props.options" :key="option.key" :value="option.key">
        {{ option.label || option.name }}
      </option>
    </select>
  </label>
</template>

<script>
/** Design filter (.fld): a label over a select; options are [{ key, label | name }]. */
export default {
  name: 'PopAuthorityAdminFilter',
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: 'all' },
    options: { type: Array, default: () => [] },
  },
}
</script>
